import axios from 'axios';
import Constants from './Constants';

import moment from 'moment';

const ProcessorService = () => {
  const _headers = (accessToken) => ({
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const getAssetAllocationScenarios = (accessToken, data) =>
    axios.post(
      `${Constants.SKYAN_URL}/processor/api/v1/asset-allocation/scenario-return`,
      data,
      _headers(accessToken)
    );

  const getFlashReportData = (accessToken, planShortCode) =>
    axios.post(
      `${Constants.SKYAN_URL}/processor/api/v1/asset-allocation/flash-report`,
      {
        asOfDate: moment().format('YYYY-MM-DD'),
        planShortCode: planShortCode,
      },
      _headers(accessToken)
    );

  const sendVote = (accessToken, data) =>
    axios.get(
      `${Constants.SKYAN_URL}/processor/api/v1/ocio/voting?data=${data}`,
      _headers(accessToken)
    );

  return { getAssetAllocationScenarios, getFlashReportData, sendVote };
};
export default ProcessorService;
